export enum CommodityGroupQueryField {
  // ---------- COMMODITY INFO ----------
  id = 'id',

  // ---------- ORDERS ----------
  orderVolumeCurrentYear = 'orderVolumeCurrentYear',
  orderVolumeLastYear = 'orderVolumeLastYear',
  orderVolumeLast12Months = 'orderVolumeLast12Months',
  orderCountCurrentYear = 'orderCountCurrentYear',
  orderCountLastYear = 'orderCountLastYear',
  orderCountLast12Months = 'orderCountLast12Months',
  links = 'links',
}

export enum CommodityGroupQueryFieldGroup {
  commodityGroup = 'commodityGroup',
  order = 'order',
}
